export const theme = {
    colors: {
        primary: '#1C1C1C', 
        primary_light: '#F8F5F2', 
        secondary: '#FFC5D9', 
        white: '#FFFFFF', 
        black: '#000000', 
        para_text_color: '#A8A8A8' 
        
    },
    fonts: {
        family: 'DM Sans, sans-serif',
        weight: {
            regular: 400,
            medium: 500,
            bold: 700,
        }
    },
    breakpoints: {
        large: '1000px',
        mobile: '900px',
        small: '500px'
    }
}